const Search = () => (
  <>
    <g clipPath="url(#prefix__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.99 6.99a5.5 5.5 0 1 0 7.778 7.778A5.5 5.5 0 0 0 6.99 6.99m-.708 8.485a6.5 6.5 0 1 1 9.533-.367l3.903 3.902a.5.5 0 1 1-.708.707l-3.902-3.902a6.5 6.5 0 0 1-8.826-.34"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="prefix__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </>
)
export default Search
